import React, { useState } from "react";
import AppStatusDot from "../AppStatusDot/AppStatusDot";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import ChildRow from "../ChildRow";
import ChevronRight16 from "../../../../assets/svg/icons/common/ChevronRight16";
import styles from "./style.module.scss";

const ApplicationCard = ({ app, onClick, isSelected }) => {
  const [childAppOpen, setChildAppOpen] = useState(false);

  const handleCardClick = (e) => {
    // If there are child apps, toggle them; otherwise show details
    if (app?.child?.length > 0) {
      setChildAppOpen(!childAppOpen);
    } else {
      if (onClick) {
        onClick();
      }
    }
  };

  return (
    <>
      <div 
        className={`${styles.application_card} ${isSelected ? styles.selected : ""}`}
        onClick={handleCardClick}
      >
        <div className={styles.card_left}>
          <div className={styles.card_content}>
            <div className={styles.dba_name_container}>
              {app?.child?.length > 0 && (
                <ButtonIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    setChildAppOpen(!childAppOpen);
                  }}
                  bgColor={"transparent"}
                  className={styles.caret_button}
                >
                  <ChevronRight16 className={`${styles.caret_icon} ${childAppOpen ? styles.rotate_90 : ""}`} />
                </ButtonIcon>
              )}
              <div className={styles.dba_name}>{app?.field_dba || "-"}</div>
            </div>
          </div>
        </div>
        <div className={styles.card_right}>
          <div className={styles.status_container}>
            <AppStatusDot
              progression_id={app?.lead_progression_id}
              hasChild={app.child?.length > 0}
            />
            {app.child?.length > 0 &&
              app.child.map((child, index) => (
                <AppStatusDot
                  key={index}
                  progression_id={child?.lead_progression_id}
                  hasChild={true}
                />
              ))}
          </div>
        </div>
      </div>
      {childAppOpen && app?.child?.length > 0 && (
        <ChildRow
          children={app.child}
          organization={app?.organization?.name}
          app={app}
        />
      )}
    </>
  );
};

export default ApplicationCard;

